import React from 'react';
import xss from 'xss';
import { array } from 'prop-types';
import SeoMarkupScript from './seo_markup_script';

const SeoMarkups = ({ baseUrl, breadcrumbs = [], faqs = [] }) => (
    <div>
        {!!breadcrumbs.length && <SeoMarkupScript scriptContent={formatBreadcrbumsContent(breadcrumbs, baseUrl)}/>}
        {!!faqs.length && <SeoMarkupScript scriptContent={formatFaqsContent(faqs)}/>}
    </div>
);

SeoMarkups.propTypes = {
    breadcrumbs: array,
    faqs: array
};

export default SeoMarkups;

const formatBreadcrbumsContent = (breadcrumbs, baseUrl) => {

    const urlPrefix = `https://${baseUrl}`;
    const itemListElement = breadcrumbs.reduce((result, item, index) => {
        result.push({
            '@type': 'ListItem',
            'position': index + 1,
            'name': item.title,
            'item': `${urlPrefix}${removeUrlParams(item.url)}`
        });

        return result;
    }, []);

    const breadcrumbsScript =  {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement
    };

    return sanitizeSeo(breadcrumbsScript);
};

const formatFaqsContent = (faqs) => {
    const mainEntity = faqs.reduce((result, item) => {
        result.push({
            '@type': 'Question',
            'name': item.question,
            'acceptedAnswer': {
                '@type': 'Answer',
                'text': item.answer
            }
        });

        return result;
    }, []);

    const faqsScript = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity
    };

    return sanitizeSeo(faqsScript);
};

const removeUrlParams = (url) => url.split('?')[0];

const sanitizeSeo = (seoJson) => xss(JSON.stringify(seoJson), {
    whiteList: [],
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['a', 'script']
});
